import { Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";

type Option = {
  label: string;
  value: string;
};

type LabeledSelectBoxProps = {
  // defaultValue: Option;
	value: string;
  onChange: (value: string) => void;
  options: Option[];
  placeholder?: string;
  disabled?: boolean;
};

const LabeledSelectBox = (props: LabeledSelectBoxProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const [selectedValue, setSelectedValue] = useState(props.value || '');
  const containerRef = useRef<HTMLDivElement>(null);


	// useEffect(() => {
	// 	if (props.defaultValue) {
	// 		setSelectedValue(props.defaultValue);
	// 		props.onChange(props.defaultValue.value);
	// 	}
	// }, [props.defaultValue]);

	useEffect(() => {
		setSelectedValue(props.value || '');
	}, [props.value]);

  // 외부 클릭 시 드롭다운 닫기
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
        // setSearchTerm('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

	const getLabelByValue = (value: string) => {
    if (!value) return null;
    const matched = props.options?.find?.((opt) => opt.value === value);
    return matched?.label ?? null;
  };

	return (
		<div ref={containerRef} style={{ width: '100%' }}>
			<Typography sx={{ fontWeight: 400, fontSize: '12px', color: '#8A8A8A' }}>{props.placeholder}</Typography>
			<div style={{ display: 'flex', flexDirection: 'column' }}>
				<div
					style={{
						// width: '212px',
						// height: '46px',
						display: 'flex',
						alignItems: 'center',
						boxSizing: 'border-box',
						padding: '12px 8px 13px 8px',
						borderBottom: '1px solid #2A2A2A',
						backgroundImage: 'url("/images/icon-arr-select.png")',
						backgroundRepeat: 'no-repeat',
						backgroundPosition: 'right 8px center',
					}}
				>
					<div 
						onClick={() => setIsOpen(!isOpen)}
						style={{ 
							width: '100%', 
							fontWeight: '600', 
							fontSize: '16px',
              cursor:'pointer',
						}}
					>
						{getLabelByValue(selectedValue) ?? '전체'}
					</div>
				</div>

				{/* Dropdown options */ }
				{/* {isOpen && ( */}
					<ul 
						className="select_ul"
						style={{
							width: '100%',
							maxHeight: isOpen ? '300px' : '0px',
							overflowY: 'auto',
							overflowX: 'hidden',
							background: "#fff",
							backgroundColor: '#fff',
							borderRadius: '20px',
							boxShadow: '0 5px 10px rgba(0, 0, 0, 0.2)',
							marginTop: '10px',
							// position: 'absolute',
							// top: '100%',
							// left: 0,
							// margin: 0,
							padding: 0,
							listStyle: 'none',
							transition: 'max-height 0.5s ease',
							zIndex: 2,
						}}
					>
						<style>
            {`
              .select_ul::-webkit-scrollbar {
                width: 10px;
              }
              .select_ul::-webkit-scrollbar-thumb {
                height: 30%;
                background: #d1d1d1;
                padding: 10px 0;
                margin:100px;
                border-radius: 20px;
                border: 12px solid transparent;
              }
              .select_ul::-webkit-scrollbar-track {
                border: 4px solid transparent;
                border-radius: 20px;
              }
            `}
						</style>

						{props.options?.map((category: any, index: number) => (
							<li
								key={`category-${index}`}
								style={{ 
									display: 'flex',
									alignItems: 'center',
									padding: '0 8px',
									height: '40px',
									fontWeight: '600', 
									fontSize: '16px', 
                  cursor:'pointer'
								}}
								onClick={() => {
									setSelectedValue(category.value);
									props.onChange(category.value);
									setIsOpen(!isOpen);
								}}
							>
								{category.label}
							</li>
						))}
					</ul>
				{/* )} */}
			</div>
		</div>
	)
}

export default LabeledSelectBox;